import { Nullable } from '@/utils/types';

export const getTextFieldFormattedValue = (value: Nullable<string>): string => {
  return value || '';
}
